import React, {useContext} from 'react';
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {Avatar, Card, CardActionArea, CardContent, Paper, Slide, Typography, useTheme, Zoom} from "@mui/material";
import Grid from "@mui/material/Grid";
import {actions} from "../../../../../utils/dictionaries/Actions";
import logo from "../../../../../assets/v2/Logo-Orca.svg";
import {amber, green, indigo, red} from "@mui/material/colors";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import IconButton from "@mui/material/IconButton";
import {useHistory} from "react-router-dom";
import {setThemeType} from "../../../../../services/AppServices";
import NightsStayTwoToneIcon from "@mui/icons-material/NightsStayTwoTone";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";
import {AppContext} from "../../../../../App";


const ActionsPage = () => {
	const classes = innerStyle();
	let theme = useTheme();
	let history = useHistory();
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<header style={{
					display: "flex",
					justifyContent: "center",
					paddingBottom: 28,
					paddingTop: 20,
				}}>
					<Avatar src={logo} variant="circular" className={classes.logo}/>
					<Typography variant={"h1"} component={"h1"} align={"center"}
					            style={{color: indigo["A700"]}}>
						<b>
							<span style={{color: red[500]}}>c</span>
							<span style={{color: amber[500]}}>e</span>
							<span style={{color: indigo["A700"]}}>a</span>
							<span style={{color: green[500]}}>n</span>
						</b>
					</Typography>
				</header>
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "800ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Azioni</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Clicca sull'azione che desideri svolgere
								</Typography>
								<div className={classes.flexStart}>
									{
										Object.entries(actions).map(([key, val], index) => {
											return (
												<Zoom key={key} in={true} style={{
													transitionDelay: (index + "00ms")
												}}>
													<Card className={classes.card} elevation={0}>
														<CardActionArea className={classes.cardActionArea}
														                style={{backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark}}>
															<CardContent style={{position: "relative"}}>
																<Avatar style={{
																	backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark,
																	color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor
																}}>
																	{theme.palette.mode === "light" ? val.iconNoStyle : val.iconDark}
																</Avatar>
																<Avatar style={{
																	backgroundColor: theme.palette.mode === "light" ? val.bgColor : val.bgColorDark,
																	color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor,
																	position: "absolute",
																	bottom: 0,
																	right: 0,
																	opacity: 0.06,
																	transform: "scale(5)",
																}}>
																	{theme.palette.mode === "light" ? val.iconRoundedNoStyle : val.iconDark}
																</Avatar>
																<Typography
																	style={{color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor}}>
																	<b>{val.name}</b>
																</Typography>
																<Typography variant={"caption"}
																            style={{color: theme.palette.mode === "light" ? val.bgColorDark : val.bgColor}}>
																	{val.description}
																</Typography>
															</CardContent>
														</CardActionArea>
													</Card>
												</Zoom>
											)
										})
									}
								</div>
							</Paper>
						</Slide>
					</Grid>
					<Grid item xs={12}
					      style={{
						      display: "flex",
						      alignItems: "center",
						      alignContent: "center",
						      justifyContent: "center",
						      position: "relative"
					      }}>
						<Typography variant={"caption"} color={"textSecondary"} align={"center"}>
							Atlantis© 2022<br/>
							Atlantis S.p.A 2022-2027<br/>
							Via San Paolo 33, Torino, TO
						</Typography>
						
						<IconButton
                            style={{position: "absolute", right: 4, bottom: 4}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
							{appContext.state.theme.palette.mode === "light" ? <NightsStayTwoToneIcon/> : <WbSunnyTwoToneIcon/>}
						</IconButton>
					</Grid>
				</Grid>
			</main>
        </React.Fragment>
    );
}

export default React.memo(ActionsPage)
